import { render, staticRenderFns } from "./realOrderListForAdmin.vue?vue&type=template&id=b7e11274&scoped=true&"
import script from "./realOrderListForAdmin.vue?vue&type=script&lang=js&"
export * from "./realOrderListForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./realOrderListForAdmin.vue?vue&type=style&index=0&id=b7e11274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e11274",
  null
  
)

export default component.exports